import {routerReducer} from '@ngrx/router-store';
import {ActionReducer, ActionReducerMap, MetaReducer} from '@ngrx/store';
import {environment} from '../../../environments/environment';
import {documentsReducer, initialDocumentsState} from './documents.reducer';
import {documentDownloadReducer, initialDocumentDownloadState} from './document-download.reducer';
import {editDialogReducer, initialEditDialogState} from './edit-dialog.reducer';
import {initialInteractiveAnalysesState, interactiveAnalysesReducer} from './interactive-analyses.reducer';
import {AppState} from '../../interfaces/app-state.interface';
import {errorpageReducer, initialErrorpageState} from './errorpage.reducers';
import {uploadReducer, initialUploadState} from './upload.reducer';
import {deleteDialogReducer, initialDeleteDialogState} from './delete-dialog.reducer';
import {initialJfLibState, jfLibReducers} from '@adnova/jf-ng-components';
import {initialBeleguebersichtState, beleguebersichtReducer} from './beleguebersicht.reducer';


export const initialDopoState: AppState = {
  ...initialJfLibState,
  documents: initialDocumentsState,
  documentDownload: initialDocumentDownloadState,
  editDialog: initialEditDialogState,
  interactiveAnalyses: initialInteractiveAnalysesState,
  errorpageState: initialErrorpageState,
  upload: initialUploadState,
  deleteDialog: initialDeleteDialogState,
  beleguebersicht: initialBeleguebersichtState,
};

export const reducers: ActionReducerMap<AppState> = {
  ...jfLibReducers,
  router: routerReducer,
  documents: documentsReducer,
  documentDownload: documentDownloadReducer,
  editDialog: editDialogReducer,
  interactiveAnalyses: interactiveAnalysesReducer,
  errorpageState: errorpageReducer,
  upload: uploadReducer,
  deleteDialog: deleteDialogReducer,
  beleguebersicht: beleguebersichtReducer,
};

export function logger(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [logger] : [];
